import QuizSettingsEntity from '@/modules/corporate/modules/quiz/entity/QuizSettings';
import getModifiedAttempts from '@/modules/corporate/modules/quiz/views/QuizDetails/utils/getQuizModifiedAttempts';
import { QuizResultEnum, QuizRetakeTypeEnum } from '@/types/schema';

import { getIsQuizInProgress } from '../../../../utils';
import { QuizDetailsContentFragment } from '../../graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '../../graphql/fragments/generated/QuizDetailsPerformance';

export const getCanRetakeQuiz = (
  content: QuizDetailsContentFragment,
  quizPerformance?: QuizDetailsPerformanceFragment,
) => {
  if (getIsQuizInProgress(quizPerformance)) {
    return { canRetakeQuiz: false, cannotRetakeSincePassed: false };
  }

  const { settings } = content;
  const retakeSettings = QuizSettingsEntity.getRetakeSettings(settings);
  const allowedAttempts = QuizSettingsEntity.getAllowedAttempts(retakeSettings);

  const attemptsHistory = getModifiedAttempts(quizPerformance);
  const isRetakeLeft = attemptsHistory.length < allowedAttempts;

  switch (retakeSettings.retakeType) {
    case QuizRetakeTypeEnum.FailedLearners: {
      const hasFailed = quizPerformance?.maxSubmissionDetails?.result === QuizResultEnum.Fail;

      return { canRetakeQuiz: hasFailed && isRetakeLeft, cannotRetakeSincePassed: !hasFailed };
    }
    default: {
      return { canRetakeQuiz: isRetakeLeft, cannotRetakeSincePassed: false };
    }
  }
};
